<template>
  <p class="open-sans-font custom-span-contact position-relative">
    <i class="fa fa-map position-absolute"></i>
    <span class="d-block">Address Point</span>Mexico, Pampanga, Philippines 2021
  </p>
  <!-- {/* End .custom-span-contact */} -->

  <p class="open-sans-font custom-span-contact position-relative">
    <i class="fa fa-envelope-open position-absolute"></i>
    <span class="d-block">mail me</span>
    <a href="mailto:admin@jomarmanalo.dev">admin@jomarmanalo.dev</a>
  </p>
  <!-- {/* End .custom-span-contact */} -->

  <p class="open-sans-font custom-span-contact position-relative">
    <i class="fa fa-phone-square position-absolute"></i>
    <span class="d-block">call me</span>
    <a href="Tel: +639266469246">+63 926 646 9246</a>
  </p>
  <!-- {/* End .custom-span-contact */} -->
</template>

<script>
export default {};
</script>
